import { Dispatch } from 'redux';
import * as deviceApi from '../../api/device-api';
import { IPatientDevice } from '../../models/device';
import { IResult } from '../../models/result-models';
import { apiCallError, beginApiCall } from '../api/api-status-action';

export const LOAD_DEVICE_SUCCESS = 'LOAD_DEVICE_SUCCESS';
export const LOAD_DEVICE_ERROR = 'LOAD_DEVICE_ERROR';
export const CLEAR_DEVICE_DETAILS_SUCCESS = 'CLEAR_DEVICE_DETAILS_SUCCESS';

export const loadDeviceSuccess = (result: IResult<IPatientDevice>) => ({
    type: LOAD_DEVICE_SUCCESS,
    result,
});

export const clearDeviceDetailsSuccess = () => ({
    type: CLEAR_DEVICE_DETAILS_SUCCESS,
});

// Thunks
export const loadDevice = (serialNumber1: string) => {
    console.log('Load device entry');
    return async (dispatch: Dispatch) => {
        try {
            //dispatch(beginApiCall());
            const result = await deviceApi.getDevice(serialNumber1);
            dispatch(loadDeviceSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
            console.log('Load device error');
            throw error;
        }
    };
};

export const clearDeviceDetails = () => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch(clearDeviceDetailsSuccess());
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};
